import axios from 'axios';
import { API_URL } from '../config/env';

const BASE_URL = API_URL;

export const axiosPublic = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
});

export default axios.create({ baseURL: BASE_URL });
